(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-cronologia-animada"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-results-timeline')) {
    class SPResultsTimeline extends HTMLElement {
      constructor() {
        super();
        this.frame = 0;
        this.started = false;
        this.requestUpdate = this.requestUpdate.bind(this);
        this.updateProgress = this.updateProgress.bind(this);
      }

      connectedCallback() {
        if (this.started) return;
        this.started = true;

        this.shell = this.querySelector('.sptl__timeline-shell');
        this.rail = this.querySelector('.sptl__rail');
        this.fill = this.querySelector('.sptl__rail-fill');
        this.steps = Array.from(this.querySelectorAll('.sptl__step'));
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!this.shell || this.steps.length === 0) return;

        window.addEventListener('scroll', this.requestUpdate, { passive: true });
        window.addEventListener('resize', this.requestUpdate, { passive: true });
        this.addQueryListener(this.mobileQuery);
        this.addQueryListener(this.reducedMotionQuery);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.requestUpdate);
          this.resizeObserver.observe(this.shell);
        }

        this.updateProgress();
      }

      disconnectedCallback() {
        if (!this.started) return;
        this.started = false;

        if (this.frame) window.cancelAnimationFrame(this.frame);
        window.removeEventListener('scroll', this.requestUpdate);
        window.removeEventListener('resize', this.requestUpdate);
        this.removeQueryListener(this.mobileQuery);
        this.removeQueryListener(this.reducedMotionQuery);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.frame = 0;
      }

      addQueryListener(query) {
        if (!query) return;
        if (typeof query.addEventListener === 'function') {
          query.addEventListener('change', this.requestUpdate);
        } else if (typeof query.addListener === 'function') {
          query.addListener(this.requestUpdate);
        }
      }

      removeQueryListener(query) {
        if (!query) return;
        if (typeof query.removeEventListener === 'function') {
          query.removeEventListener('change', this.requestUpdate);
        } else if (typeof query.removeListener === 'function') {
          query.removeListener(this.requestUpdate);
        }
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = 0;
          this.updateProgress();
        });
      }

      resetDesktop() {
        this.classList.remove('is-scroll-enabled');
        if (this.fill) this.fill.style.removeProperty('height');
        this.steps.forEach((step) => step.classList.remove('is-reached'));
      }

      updateProgress() {
        const animationEnabled = this.dataset.mobileAnimation === 'true';

        if (!animationEnabled || !this.mobileQuery.matches || !this.rail || !this.fill) {
          this.resetDesktop();
          return;
        }

        this.classList.add('is-scroll-enabled');

        const railRect = this.rail.getBoundingClientRect();
        const maximumProgress = Math.max(0, railRect.height);
        if (maximumProgress === 0) return;

        if (this.reducedMotionQuery.matches) {
          this.fill.style.height = `${maximumProgress}px`;
          this.steps.forEach((step) => step.classList.add('is-reached'));
          return;
        }

        const configuredTrigger = Number.parseFloat(this.dataset.scrollTrigger);
        const triggerPercent = Number.isFinite(configuredTrigger) ? configuredTrigger : 72;
        const triggerRatio = Math.min(0.9, Math.max(0.5, triggerPercent / 100));
        const triggerPoint = window.innerHeight * triggerRatio;
        const progress = Math.max(0, Math.min(maximumProgress, triggerPoint - railRect.top));

        this.fill.style.height = `${progress}px`;

        this.steps.forEach((step) => {
          const marker = step.querySelector('.sptl__marker');
          if (!marker) return;
          const markerRect = marker.getBoundingClientRect();
          const markerCenter = markerRect.top + (markerRect.height / 2);
          step.classList.toggle('is-reached', markerCenter <= triggerPoint);
        });
      }
    }

    customElements.define('sp-results-timeline', SPResultsTimeline);
  }

  } catch(e) { console.error(e); }
})();
})();
